import {
    SAVE_PRODUCT_CONFIGURATON,
    SAVE_PRODUCT_CONFIGURATON_FAILURE,
    SAVE_PRODUCT_CONFIGURATON_SUCCESS,
} from 'store/actions/types';

export const saveProductConfiguration = (payload) => {
    return {
        type: SAVE_PRODUCT_CONFIGURATON,
        payload: payload,
    };
};

export const saveProductConfigurationFailure = (error) => {
    return {
        type: SAVE_PRODUCT_CONFIGURATON_FAILURE,
        error: error,
    };
};

export const saveProductConfigurationSuccess = (payload, response) => {
    return {
        type: SAVE_PRODUCT_CONFIGURATON_SUCCESS,
        payload: payload,
        response: response,
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/products/configuration/saveConfiguration.js